// extracted by mini-css-extract-plugin
export default {"mCard":"_D-z","image":"aE-z","imageNoBackground":"bE-z","imageHasCategory":"cE-z","fullWidth":"dE-z"};